import * as React from "react";
import "./PropertyCard.scss";
import { ShowProcessedImage } from '../common/ggfx-client/module/components/show-image';
import { CurrConvertPrice } from '../currency-converter/CurrConvertPrice'
import imageConfig from "../../../static/images/config.json"
import PropertyIMG1 from "../../images/search-result/1.jpg";
import { useLocation } from "@reach/router"
import { Link } from "@StarberryUtils";
import ImageModule from "../common/Image_Module";
const PropertyCard = (props) => {

  const location = useLocation();
  var location_link = process.env.GATSBY_SITE_URL+location.pathname;

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  var whatsapp_link = `https://wa.me/971586234140?text=Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
  if(location.search.indexOf("utm_source") > 0){
      whatsapp_link = `https://wa.me/971586234140?text=*G*%20Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
  }

  return (
    <React.Fragment>
      <div className="properties-wrapper">
        {
          props.images && props.images.length != 0 ?
            <div className="properties-wrapper-rented">
              {(props.status == "Sold" || props.status == "Rented") &&
                <button className="btn btn-secondary tag-btn">{props.status}</button>
              }
              {!props.noResult ?
                <img loading="lazy" src={props.images[0].url} alt={`${props.PropertyHeading} - Dacha`} />
                :
                // <ShowProcessedImage 
                //     images={props.images[0]} 
                //     attr={{ className: 'mb-0 img-fluid', 
                //     alt: `${props.PropertyHeading} banner - Dacha` }} 
                //     transforms={imageConfig.property.searchResults1.sizes} 
                // />
                <ImageModule 
                      ImageSrc={props.images[1]} 
                      attr={{ alt: `${props.PropertyHeading} banner - Dacha` || "" }} 
                      ggfx_results={props.data?.ggfx_results} 
                      imagename="peoples.Tile_Image.tile" 
                      strapi_id={props.id}
                      className= 'mb-0 img-fluid'
                  />
              }
            </div>
            :
            <div className="properties-wrapper-sold">
              {(props.status == "Sold" || props.status == "Rented") &&
                <button className="btn btn-secondary tag-btn">{props.status}</button>
              }
              <picture>
                <img loading="lazy" src={PropertyIMG1} alt={`${props.PropertyHeading} - Dacha`} />
              </picture>
            </div>
        }

        {/* <div className="banner-btn">
            <storng
              className="video-btn"
              onClick={(e) => {
                setPlay(true);
              }}
            >
              <i className="icon-video"></i>
            </storng>
          </div> */}
        <span className="sm-content d-md-none">{props.OfferText}</span>
      </div>
      <div className="about-properties">
        <div className="properties-info">
          <h2>
            {capitalizeFirstLetter(props.PropertyHeading)} 
          </h2>
          {props.poa === "Y" ?
            <span className="total">PRICE ON APPLICATION</span>
            :
            <span className="total">{CurrConvertPrice(props.PropertyPrice.toLocaleString())} {(props.tag == "for-rent") ? 'per year' : null}</span>
          }
          <span className="about-location">
            <i className="icon-location"></i>
              <span className="location-info">{props.PropertyAddress && (props.PropertyAddress + ", ")}{props.PropertyArea && (props.PropertyArea + ", ")} {props.PropertyTown && (props.PropertyTown)}</span>
          </span>
        </div>
        {props.BedCount > 0 && props.BathCount > 0 &&
        <div className="properties-icons">
          {props.department == "residential" && props.BedCount > 0 &&
            <span className="text">
              <i className="icon-bedroom"></i>
              <span className="sm-text">{props.BedCount}</span>
            </span>
          }
          {props.department == "residential" && props.BathCount > 0 &&
            < span className="text">
              <i className="icon-bath"></i>
              <span className="sm-text">{props.BathCount}</span>
            </span>
          }
          {/* {props.ReceptionCount > 0 &&
            < span className="text">
              <i className="icon-sofa"></i>
              <span className="sm-text">{props.ReceptionCount}</span>
            </span> 
          } */}
          { props.areaNumber > 0 &&
          <span className="text">
            <i className="icon-space"></i>
            <span className="sm-text">
              {props.areaNumber} ft<sup>2</sup>
            </span>
          </span>
        }
        </div>
        }
        {props?.IntroText && 
        <div className={`strapline-text text-xs`}>
            <p>{props?.IntroText} <span class="read-more-btn" aria-expanded="false" aria-controls="content">read more</span></p>
        </div>
        }
        <div className="agent-info-details"> 
          <Link href={`tel:+971 4 423 2006`} className="agent-contact agent-phone"><i class="icon-people-phone"></i> Call</Link>
          <a href={'mailto:info@dacha.ae'} className="agent-contact agent-email"><i class="icon-people-mail"></i> Email</a>
          <Link href={whatsapp_link} className="agent-contact agent-whatsapp" target="_blank" ><i class="whatsapp-icon"></i> <span className="whatsapp-text">WhatsApp</span></Link>
        </div>
      </div>
    </React.Fragment >
  );
};

export default PropertyCard;